import React, { useState } from "react";
import "./Livechat.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaperclip,
  faSmile,
  faUserTie,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import { faFacebookMessenger } from "@fortawesome/free-brands-svg-icons";

export default function Livechat() {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [currentMessage, setCurrentMessage] = useState("");

  function toggleChat() {
    setIsOpen((prev) => !prev);
  }

  function handleSendMessage() {
    if (currentMessage.trim()) {
      setMessages((prev) => [
        ...prev,
        { sender: "user", text: currentMessage },
      ]);
      setCurrentMessage("");
    }
  }

  return (
    <div className="livechat">
      {/* Nút mở chat */}
      <div className="chat-toggle-button" onClick={toggleChat}>
        <FontAwesomeIcon
          icon={faFacebookMessenger}
          size="2x"
          color={isOpen ? "#333" : "#007bff"}
        />
      </div>

      {/* Hộp chat */}
      <div
        className={`chat-box ${
          isOpen ? "animate-chat-open" : "animate-chat-close"
        }`}
      >
        {isOpen && (
          <>
            {/* Header */}
            <div className="head-chat d-flex justify-content-between align-items-center">
              <h6 className="m-0">Customer Support</h6>
              <p className="m-0 text-muted bg-light">Let's Chat App</p>
            </div>

            {/* Body */}
            <div className="body-chat">
              <p className="adim-text-chat">
                {" "}
                <FontAwesomeIcon icon={faUserTie} /> Chào bạn. Mình có thể giúp
                gì cho bạn?
              </p>
              {messages.map((msg, index) => (
                <div
                  key={index}
                  className={
                    msg.sender === "user" ? "user-message" : "admin-message"
                  }
                >
                  {msg.text}
                </div>
              ))}
            </div>

            {/* Footer */}
            <div className="footer-chat d-flex align-items-center">
              <FontAwesomeIcon icon={faUserTie} />

              <input
                type="text"
                className="chat-input"
                placeholder="Enter Message!"
                value={currentMessage}
                onChange={(e) => setCurrentMessage(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && handleSendMessage()}
              ></input>
              <button className="icon-button">
                <FontAwesomeIcon icon={faSmile} />
              </button>
              <button className="icon-button">
                <FontAwesomeIcon icon={faPaperclip} />
              </button>
              <button className="send-button" onClick={handleSendMessage}>
                <FontAwesomeIcon icon={faPaperPlane} />
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
